import { render, staticRenderFns } from "./Calendarios.vue?vue&type=template&id=3fe56388&scoped=true"
import script from "./Calendarios.vue?vue&type=script&lang=js"
export * from "./Calendarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe56388",
  null
  
)

export default component.exports